import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import classNames from 'classnames';
import moment from 'moment-timezone';
import {updateTimes} from 'search-request/search-request-actions';
import withConfig from 'config/withConfig';
import AirportDateRangePickerDesktop from './AirportDateRangePickerDesktop';
import AirportDateRangePickerMobile from './AirportDateRangePickerMobile';

class SearchAirportControls extends Component {
    static propTypes = {
        className: PropTypes.string,
        isMobile: PropTypes.bool,
        title: PropTypes.string,
        showCondensedMobileView: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        updateSearchTimes: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
        displayDateFormat: PropTypes.string,
    };

    _onSearchClick = ({starts, ends}) => {
        const {updateSearchTimes, onSubmit} = this.props;

        updateSearchTimes({
            starts,
            ends,
        });

        if (onSubmit) {
            onSubmit({starts, ends});
        }
    };

    render() {
        const {
            className,
            isMobile,
            title,
            showCondensedMobileView,
            starts,
            ends,
            displayDateFormat,
        } = this.props;
        const classes = classNames('SearchAirportControls', className);
        const selectedStartDate = starts
            ? moment(starts).format(displayDateFormat)
            : null;
        const selectedEndDate = ends
            ? moment(ends).format(displayDateFormat)
            : null;

        return (
            <div className={classes}>
                {!isMobile && (
                    <AirportDateRangePickerDesktop
                        selectedStartDate={selectedStartDate}
                        selectedEndDate={selectedEndDate}
                        id="AirportDateRangePicker"
                        onSearchClick={this._onSearchClick}
                    />
                )}
                {isMobile && (
                    <AirportDateRangePickerMobile
                        title={title}
                        showCondensed={showCondensedMobileView}
                        selectedStartDate={selectedStartDate}
                        selectedEndDate={selectedEndDate}
                        isEditing={
                            Boolean(selectedStartDate) &&
                            Boolean(selectedEndDate)
                        }
                        id="AirportDateRangePicker"
                        onSearchClick={this._onSearchClick}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        searchRequest: {starts, ends},
    } = state;

    return {
        starts,
        ends,
    };
};

const mapDispatchToProps = {
    updateSearchTimes: updateTimes,
};

const enhance = compose(
    withConfig(['displayDateFormat', 'isMobile']),
    connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(SearchAirportControls);
